/* sugar:assets/testimonials.js@2.3.2 */
/*
  Testimonial cards — everything the Grid and the Slider both need.

  A card is drawn by a child block that cannot see its parent's settings, so
  the parent publishes them on its own root: values as --tc-* variables read by
  CSS, and the two things CSS cannot do — the verified label's text and a date
  written relative to today — as data attributes read here.

  Masonry and Show More belong to the Grid alone and are skipped elsewhere.
*/
(function () {
  'use strict';

  /* Every Grid and Slider on the page asks for this file, so the first one in
     does the work for all of them. */
  if (window.__sugarTestimonials) return;
  window.__sugarTestimonials = true;

  var MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH_LONG = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  function ordinal(n) {
    var suffix = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
  }

  function formatDate(value, format) {
    var parts = String(value).split('-');
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    if (isNaN(d.getTime())) return '';

    var diffMs = new Date() - d;
    var diffH = Math.floor(diffMs / 3600000);
    var diffD = Math.floor(diffMs / 86400000);

    if (format === 'relative' || format === 'relative_short') {
      var short = format === 'relative_short';
      if (diffD < 0 || diffH < 1) return short ? 'now' : 'just now';
      if (diffH < 24) return short ? diffH + 'h ago' : diffH + (diffH === 1 ? ' hour ago' : ' hours ago');
      if (diffD < 7) return short ? diffD + 'd ago' : diffD + (diffD === 1 ? ' day ago' : ' days ago');
      if (diffD < 30) {
        var w = Math.floor(diffD / 7);
        return short ? w + 'w ago' : w + (w === 1 ? ' week ago' : ' weeks ago');
      }
      if (diffD < 365) {
        var mo = Math.floor(diffD / 30);
        return short ? mo + 'mo ago' : mo + (mo === 1 ? ' month ago' : ' months ago');
      }
      var yr = Math.floor(diffD / 365);
      return short ? yr + 'y ago' : yr + (yr === 1 ? ' year ago' : ' years ago');
    }

    var dd = d.getDate();
    var mm = d.getMonth();
    var yy = d.getFullYear();
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    switch (format) {
      case 'long': return MONTH_LONG[mm] + ' ' + dd + ', ' + yy;
      case 'numeric': return pad(mm + 1) + '/' + pad(dd) + '/' + yy;
      case 'day_month': return dd + ' ' + MONTH_SHORT[mm] + ' ' + yy;
      case 'month_day': return MONTH_LONG[mm] + ' ' + dd;
      case 'month_day_ordinal': return MONTH_LONG[mm] + ' ' + ordinal(dd);
      case 'long_ordinal': return MONTH_LONG[mm] + ' ' + ordinal(dd) + ', ' + yy;
      default: return MONTH_SHORT[mm] + ' ' + dd + ', ' + yy;
    }
  }

  /* ---- card content the parent owns ---------------------------------- */

  function fillCards(host) {
    var label = host.dataset.tcVlabel || '';
    if (label) {
      host.querySelectorAll('.testimonial-card__vlabel').forEach(function (el) {
        el.textContent = label;
      });
    }

    /* An emoji or flag token has no mask URL, so the parent hands over real
       markup to copy into each badge instead. */
    var iconTemplate = host.querySelector('template[data-tc-vicon]');
    if (iconTemplate) {
      host.querySelectorAll('.testimonial-card__vicon').forEach(function (el) {
        if (el.firstElementChild) return;
        el.appendChild(iconTemplate.content.cloneNode(true));
      });
    }

    /* The product row's button and label, the same way. */
    [['tcPbtn', '.testimonial-card__pbtn-label'], ['tcPlabel', '.testimonial-card__plabel']].forEach(function (pair) {
      var text = host.dataset[pair[0]] || '';
      if (!text) return;
      host.querySelectorAll(pair[1]).forEach(function (el) {
        el.textContent = text;
      });
    });

    var format = host.dataset.tcDateFormat || 'relative';
    host.querySelectorAll('.testimonial-card__date[data-tc-date]').forEach(function (el) {
      el.textContent = formatDate(el.dataset.tcDate, format);
    });
  }

  /* ---- long reviews ---------------------------------------------------

     A wall of reviews only reads well when the cards are a similar size, so
     the host can cap the quote at a number of lines. Whether a given review
     actually overflows that cap is a question only the browser can answer, so
     the button appears per card, after measuring. */

  function setupClamp(host, onToggle) {
    if (!host.hasAttribute('data-tc-clamp')) return;
    var more = host.dataset.tcReadMore || 'Read more';
    var less = host.dataset.tcReadLess || 'Read less';

    /* Whether a review overflows depends on the font it is finally set in, so
       measure again once that has arrived. */
    if (!host.dataset.tcClampFonts && document.fonts && document.fonts.ready) {
      host.dataset.tcClampFonts = '1';
      document.fonts.ready.then(function () { setupClamp(host, onToggle); });
    }

    /* Reads first, writes after: measuring a card right after inserting the
       previous card's button forces the page to lay out again for every card,
       and a wall of ninety cards spent seconds in that loop on a phone. */
    var pending = [];
    host.querySelectorAll('.testimonial-card__text').forEach(function (el) {
      if (el.dataset.tcClamp) return;
      if (el.scrollHeight <= el.clientHeight + 1) return;
      pending.push(el);
    });
    pending.forEach(function (el) {
      el.dataset.tcClamp = '1';

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'testimonial-card__more';
      button.textContent = more;
      button.setAttribute('aria-expanded', 'false');
      el.insertAdjacentElement('afterend', button);

      button.addEventListener('click', function () {
        var open = el.classList.toggle('is-expanded');
        button.textContent = open ? less : more;
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (onToggle) onToggle();
      });
    });

    if (onToggle) onToggle();
  }

  /* ---- review photos --------------------------------------------------

     One dialog for the whole page: a review photo is worth looking at full
     size, and every grid wants the same thing from it. */

  var lightbox = null;

  function openLightbox(src, alt) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'testimonial-lightbox';
      lightbox.innerHTML =
        '<div class="testimonial-lightbox__frame">' +
        '<img alt="">' +
        '<button type="button" class="testimonial-lightbox__close" aria-label="Close">&times;</button>' +
        '</div>';
      document.body.appendChild(lightbox);
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox || event.target.closest('.testimonial-lightbox__close')) {
          lightbox.close();
        }
      });
    }
    var img = lightbox.querySelector('img');
    /* The last photo would show until the new one arrives, so the frame stays
       empty until this src has loaded. */
    img.removeAttribute('src');
    lightbox.classList.add('is-loading');
    var reveal = function () { lightbox.classList.remove('is-loading'); };
    img.onload = reveal;
    img.onerror = reveal;
    img.alt = alt || '';
    img.src = src;
    if (lightbox.showModal) lightbox.showModal();
  }

  function setupLightbox(host) {
    if (host.dataset.tcLightboxWired) return;
    host.dataset.tcLightboxWired = '1';

    host.addEventListener('click', function (event) {
      var media = event.target.closest ? event.target.closest('.testimonial-card__media') : null;
      if (!media || media.hasAttribute('data-tc-video')) return;
      var img = media.querySelector('img');
      if (!img) return;
      openLightbox(media.dataset.tcFull || img.currentSrc || img.src, img.alt);
    });
  }

  /* ---- review videos --------------------------------------------------

     A review with a video shows its photo and a play button. A tap copies the
     video out of its <template> (nothing downloads before that) and lays it
     over the photo at the photo's own size, so the card does not move, then
     plays it with sound. One review plays at a time. */

  function playCardVideo(media) {
    var video = media.querySelector('.testimonial-card__video');
    if (!video) {
      var template = media.querySelector('template');
      var img = media.querySelector('img');
      if (!template) return;
      /* Read the photo's box first, then write: the video takes its place. */
      var w = media.clientWidth || 1;
      var h = media.clientHeight || 1;
      var box = img ? { l: img.offsetLeft, t: img.offsetTop, w: img.offsetWidth, h: img.offsetHeight } : { l: 0, t: 0, w: w, h: h };
      video = template.content.querySelector('video');
      if (!video) return;
      video = video.cloneNode(true);
      video.style.left = (box.l / w) * 100 + '%';
      video.style.top = (box.t / h) * 100 + '%';
      video.style.width = (box.w / w) * 100 + '%';
      video.style.height = (box.h / h) * 100 + '%';
      media.appendChild(video);
    }
    media.classList.add('is-playing');
    var play = video.play();
    if (play && play.catch) play.catch(function () {});
  }

  function setupVideos(host) {
    if (host.dataset.tcVideoWired) return;
    host.dataset.tcVideoWired = '1';
    host.addEventListener('click', function (event) {
      if (!event.target.closest || event.target.closest('video')) return;
      var media = event.target.closest('.testimonial-card__media[data-tc-video]');
      if (!media || !host.contains(media)) return;
      /* A grid that opens the full review on a click leaves this tap to the video. */
      event.preventDefault();
      event.stopImmediatePropagation();
      playCardVideo(media);
    });
  }

  document.addEventListener('play', function (event) {
    var playing = event.target;
    if (!playing.classList || !playing.classList.contains('testimonial-card__video')) return;
    document.querySelectorAll('.testimonial-card__video').forEach(function (other) {
      if (other !== playing && !other.paused) other.pause();
    });
  }, true);

  /* ---- grid: masonry, sorting, show more ------------------------------ */

  /* Masonry rows are 1px (coarser only on a very tall grid, so the row count
     stays far under the browsers' grid line limits). */
  var ROW_LINES = 5000;

  /* -- Highlight children on cloned cards --

     A Highlight Background on the grid, set to tug or sweep, watches each bold
     word once (data-hb-seen) and lights it (data-hb-live) as it scrolls in.
     cloneNode copies both, so a cloned card would sit unwatched and half
     painted. The wall's second half strips them and asks for a rescan of the
     copy, which finds the grid's marker above it and watches the copy's words;
     the popup opens the review fully painted instead. */
  var HB_WORDS = '.sw-content strong, .sw-content em, .sw-content u, .sw-content span[style*="underline"]';

  function rearmHighlights(root) {
    Array.prototype.slice.call(root.querySelectorAll('[data-hb-seen], [data-hb-live]')).forEach(function (word) {
      word.removeAttribute('data-hb-seen');
      word.removeAttribute('data-hb-live');
    });
    if (window.SugarHighlightBackground) {
      window.SugarHighlightBackground.init(root);
    } else {
      root.dispatchEvent(new CustomEvent('sugar:highlight:scan', { bubbles: true }));
    }
  }

  function paintHighlights(root) {
    Array.prototype.slice.call(root.querySelectorAll(HB_WORDS)).forEach(function (word) {
      word.setAttribute('data-hb-live', '');
    });
  }

  function Grid(host) {
    this.host = host;
    this.list = host.querySelector('.sugar-testimonial-grid__list');
    if (!this.list) return;

    this.cards = Array.prototype.slice.call(this.list.querySelectorAll('li[data-rating]'));
    this.order = this.cards.slice();
    this.revealed = 0;
    this.frame = 0;

    this.wall = host.hasAttribute('data-tc-wall');
    this.setupShowMore();
    this.setupSummary();
    this.setupSortBar();
    this.setupFilterTabs();
    if (this.wall) this.setupWall();
    else this.setupMasonry();
    this.setupPopup();
    this.apply();
  }

  /* A click anywhere on a card, its photo included, opens the full review;
     the Read more button and any link inside keep their own job. */
  Grid.prototype.setupPopup = function () {
    if (this.host.dataset.tcWallClick !== 'popup') return;
    var self = this;
    var cardSelector = this.wall ? '.sugar-testimonial-grid__col-track > li' : '.sugar-testimonial-grid__list > li[data-rating]';
    this.host.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) return;
      var li = event.target.closest(cardSelector);
      if (li && self.host.contains(li)) self.openPopup(li);
    });
  };

  /* Each child block also emits its own <style> and <script> as siblings, so
     only the list items are real grid children. */
  Grid.prototype.items = function () {
    return Array.prototype.slice.call(this.list.querySelectorAll(':scope > li'));
  };

  Grid.prototype.isMobile = function () {
    return window.innerWidth <= 749;
  };

  /* -- Show More -- */

  Grid.prototype.setupShowMore = function () {
    this.button = this.host.querySelector('[data-tc-show-more]');
    if (!this.button) return;

    var wrap = this.button.closest('li') || this.button;
    this.buttonRow = wrap;
    this.rowsDesktop = parseInt(this.button.dataset.rowsDesktop, 10) || 0;
    this.rowsMobile = parseInt(this.button.dataset.rowsMobile, 10) || 0;
    this.host.setAttribute('data-tc-show-more-js', '');

    var self = this;
    this.button.addEventListener('click', function () {
      self.revealed += self.batch();
      self.apply();
    });
  };

  Grid.prototype.columns = function () {
    var value = this.isMobile() ? this.host.dataset.tcColsM : this.host.dataset.tcCols;
    var cols = parseInt(value, 10) || 1;
    // Tablets cap the row the way the stylesheet does (base.css, data-sw-row).
    if (!this.isMobile() && window.innerWidth < 1200) {
      var w = this.host.getBoundingClientRect().width;
      if (w > 0) cols = Math.min(cols, w < 400 ? 1 : w < 610 ? 2 : w < 820 ? 3 : w < 1030 ? 4 : cols);
    }
    return cols;
  };

  Grid.prototype.batch = function () {
    return (this.isMobile() ? this.rowsMobile : this.rowsDesktop) * this.columns();
  };

  /* The filter decides which cards exist as far as everything else is
     concerned, so Show More counts rows of what is actually on screen. */
  Grid.prototype.pool = function () {
    var level = this.filter;
    var tag = this.tag;
    var out = [];
    this.cards.forEach(function (card) {
      var keep = !level || parseInt(card.dataset.rating, 10) === level;
      if (keep && tag) {
        var tags = (card.dataset.tags || '').split(',');
        keep = tags.indexOf(tag) !== -1;
      }
      card.classList.toggle('is-filtered', !keep);
      if (keep) out.push(card);
    });
    return out;
  };

  /* -- Filter tabs --

     A tab names a tag; a card lists the tags it answers to. The tabs and the
     phone dropdown are two views of one choice, so either one moves both. */

  Grid.prototype.setupFilterTabs = function () {
    var root = this.host.querySelector('[data-tc-filter]');
    if (!root) return;
    var self = this;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tc-tag]'));
    var select = root.querySelector('[data-tc-filter-select]');
    var current = root.querySelector('[data-tc-filter-current]');
    this.tag = '';

    var mark = function () {
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-pressed', tab.dataset.tcTag === self.tag ? 'true' : 'false');
      });
      if (select && select.value !== self.tag) select.value = self.tag;
      if (current && select) {
        var option = select.options[select.selectedIndex];
        current.textContent = option ? option.textContent : '';
      }
    };

    this.setTag = function (tag) {
      self.tag = tag || '';
      self.revealed = 0;
      mark();
      self.apply();
    };

    tabs.forEach(function (tab) {
      // A second click on the active tab clears it, so the grid can show every card even with the All tab hidden.
      tab.addEventListener('click', function () {
        self.setTag(tab.dataset.tcTag === self.tag ? '' : tab.dataset.tcTag);
      });
    });
    if (select) {
      select.addEventListener('change', function () { self.setTag(select.value); });
    }
    mark();
  };

  Grid.prototype.apply = function () {
    var pool = this.pool();
    if (this.wall) {
      if (this.buttonRow) this.buttonRow.style.display = 'none';
      this.layoutWall(pool);
      if (this.clamp) this.clamp();
      this.paceWall();
      return;
    }
    if (this.button) {
      var visible = this.batch() + this.revealed;
      pool.forEach(function (card, i) {
        card.classList.toggle('is-shown', i < visible);
      });
      this.buttonRow.style.display = visible >= pool.length ? 'none' : '';
    }
    /* A card that was hidden could not be measured, so anything just revealed
       still needs its Read more decision. */
    if (this.clamp) this.clamp();
    this.relayout();
  };

  Grid.prototype.setFilter = function (level) {
    this.filter = this.filter === level ? 0 : level;
    this.revealed = 0;
    if (this.summary) this.summary.mark(this.filter);
    this.apply();
  };

  /* -- Summary --

     The average, the count and the star breakdown are read off the cards, so a
     merchant never types a number that can go stale. */

  Grid.prototype.setupSummary = function () {
    var root = this.host.querySelector('[data-tc-summary]');
    if (!root) return;

    var cards = this.cards;
    var total = cards.length;
    var counts = [0, 0, 0, 0, 0, 0];
    var sum = 0;

    cards.forEach(function (card) {
      var rating = parseInt(card.dataset.rating, 10);
      if (!(rating >= 1 && rating <= 5)) return;
      counts[rating] += 1;
      sum += rating;
    });

    var rated = counts.slice(1).reduce(function (a, b) { return a + b; }, 0);
    var average = rated ? sum / rated : 0;

    /* Star counts typed on the summary were written on the server; only the
       filter still answers to the reviews actually on the page. */
    var fixed = root.hasAttribute('data-tc-summary-fixed');

    if (!fixed) {
      var averageEl = root.querySelector('[data-tc-average]');
      /* One decimal, but a whole number stays whole — 5.0 reads as inflated. */
      if (averageEl) averageEl.textContent = rated ? String(Math.round(average * 10) / 10) : '';

      var starsEl = root.querySelector('[data-tc-average-stars]');
      if (starsEl) starsEl.style.setProperty('--tc-rating', average.toFixed(2));

      /* The heading can carry the count too, through its [count] token. */
      root.querySelectorAll('[data-tc-count]').forEach(function (countEl) {
        countEl.textContent = total;
      });
    }

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-tc-level]'));
    rows.forEach(function (row) {
      var level = parseInt(row.dataset.tcLevel, 10);
      if (!fixed) {
        var pct = rated ? Math.round((counts[level] / rated) * 100) : 0;
        var fill = row.querySelector('.sugar-testimonial-summary__fill');
        var label = row.querySelector('[data-tc-pct]');
        if (fill) fill.style.width = pct + '%';
        if (label) label.textContent = pct + '%';
      }
      if (counts[level]) row.removeAttribute('data-tc-empty');
      else row.setAttribute('data-tc-empty', '');
    });

    var self = this;
    this.summary = {
      mark: function (level) {
        rows.forEach(function (row) {
          row.setAttribute('aria-pressed', parseInt(row.dataset.tcLevel, 10) === level ? 'true' : 'false');
        });
      },
    };

    if (!root.hasAttribute('data-tc-summary-filter')) return;
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        self.setFilter(parseInt(row.dataset.tcLevel, 10));
      });
    });
  };

  /* -- Sort bar -- */

  Grid.prototype.setupSortBar = function () {
    var bar = this.host.querySelector('.sugar-testimonial-sort-bar');
    if (!bar) return;

    var count = bar.querySelector('.sugar-testimonial-sort-bar__count');
    if (count && count.dataset.countType === 'dynamic') {
      count.textContent = this.cards.length + ' ' + (count.dataset.countLabel || 'reviews');
    }

    var select = bar.querySelector('.sugar-testimonial-sort-bar__select');
    if (!select) return;

    var self = this;
    select.addEventListener('change', function () {
      self.sort(this.value);
    });

    if (select.dataset.defaultSort && select.dataset.defaultSort !== 'default') {
      select.value = select.dataset.defaultSort;
      this.sort(select.value);
    }
  };

  Grid.prototype.sort = function (by) {
    var sorted;
    var rank = function (el) { return parseInt(el.dataset.rating, 10) || 0; };

    if (by === 'highest_rating') {
      sorted = this.cards.slice().sort(function (a, b) { return rank(b) - rank(a); });
    } else if (by === 'lowest_rating') {
      sorted = this.cards.slice().sort(function (a, b) { return rank(a) - rank(b); });
    } else if (by === 'most_recent' || by === 'oldest') {
      sorted = this.cards.slice().sort(function (a, b) {
        var da = a.dataset.date || '';
        var db = b.dataset.date || '';
        if (!da && !db) return 0;
        if (!da) return 1;
        if (!db) return -1;
        return by === 'most_recent' ? (db > da ? 1 : db < da ? -1 : 0) : (da > db ? 1 : da < db ? -1 : 0);
      });
    } else if (by === 'with_photos') {
      sorted = this.cards.slice().sort(function (a, b) {
        return (b.dataset.hasImage === 'true' ? 1 : 0) - (a.dataset.hasImage === 'true' ? 1 : 0);
      });
    } else {
      sorted = this.order;
    }

    var list = this.list;
    sorted.forEach(function (card) { list.appendChild(card); });
    this.cards = sorted;
    this.revealed = 0;
    this.apply();
  };

  /* -- Scrolling wall --

     The cards are dealt round-robin into one column per grid column; each
     column holds its cards twice so a full-height translate loops without a
     seam. Columns start at staggered offsets so the wall reads as a wall and
     not as rows. Filters rebuild the columns from whatever survives. */

  Grid.prototype.setupWall = function () {
    var self = this;
    this.host.setAttribute('data-tc-wall-js', '');
    // The filter and sort rows belong above the window, not scrolling inside it.
    var ui = Array.prototype.slice.call(this.list.querySelectorAll(':scope > li[data-tc-ui]'));
    if (ui.length) {
      var bar = document.createElement('ul');
      bar.className = 'sugar-testimonial-grid__ui';
      ui.forEach(function (li) { bar.appendChild(li); });
      this.list.parentNode.insertBefore(bar, this.list);
    }
    var relayout = function () {
      var cols = self.columns();
      if (cols !== self.wallCols) self.apply();
      else self.paceWall();
    };
    window.addEventListener('resize', relayout);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (self.clamp) self.clamp();
        self.paceWall();
      });
    }
  };

  Grid.prototype.layoutWall = function (pool) {
    var list = this.list;
    var self = this;
    // Put every original card back before dealing them out again.
    this.cards.forEach(function (card) {
      if (card.parentNode !== list) list.appendChild(card);
    });
    Array.prototype.slice.call(list.querySelectorAll(':scope > .sugar-testimonial-grid__col')).forEach(function (col) {
      col.parentNode.removeChild(col);
    });
    var cols = this.columns();
    this.wallCols = cols;
    var tracks = [];
    for (var c = 0; c < cols; c++) tracks.push([]);
    pool.forEach(function (card, i) { tracks[i % cols].push(card); });
    this.wallFull = pool.length === this.cards.length;
    tracks.forEach(function (cards, c) {
      var col = document.createElement('li');
      col.className = 'sugar-testimonial-grid__col';
      col.setAttribute('data-tc-ui', '');
      var track = document.createElement('ul');
      track.className = 'sugar-testimonial-grid__col-track';
      cards.forEach(function (card) {
        card.classList.add('is-shown');
        track.appendChild(card);
      });
      col.appendChild(track);
      var copy = null;
      if (cards.length) {
        copy = track.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        Array.prototype.slice.call(copy.children).forEach(function (li) { li.removeAttribute('data-_sf'); });
        col.appendChild(copy);
      }
      list.appendChild(col);
      /* Armed once the copy is in the document, so its words can be observed. */
      if (copy) rearmHighlights(copy);
    });
    this.paceWall();
  };

  /* Seconds per loop describes the full wall. A filter leaves each column
     with fewer cards, and the same seconds over a shorter column would crawl,
     so the full wall sets the pace in pixels per second and every column's
     duration follows its own height. Columns at one pace read as rows sliding
     past; a share of the base pace, different per column, lets them drift
     apart. The factors are fixed so a given wall always looks the same. */
  Grid.prototype.paceWall = function () {
    if (!this.wall) return;
    var cols = Array.prototype.slice.call(this.list.querySelectorAll(':scope > .sugar-testimonial-grid__col'));
    if (!cols.length) return;
    var distances = cols.map(function (col) {
      var track = col.firstElementChild;
      if (!track) return 0;
      return track.offsetHeight + (parseFloat(getComputedStyle(col).rowGap) || 0);
    });
    if (distances.some(function (d) { return d <= 0; })) return;
    var seconds = parseFloat(getComputedStyle(this.host).getPropertyValue('--tg-wall-speed')) || 60;
    /* Seconds per loop is set with the desktop wall in mind. On a phone the
       same cards stack into one or two columns three times as tall, and the
       same seconds over that height would race, so the pace is the whole
       wall's height spread over the desktop column count: the loop then takes
       as many seconds per desktop-column's worth of cards everywhere. */
    var total = distances.reduce(function (sum, d) { return sum + d; }, 0);
    var desktopCols = parseInt(this.host.dataset.tcCols, 10) || cols.length;
    if (this.wallFull || !this.wallPace) this.wallPace = total / (desktopCols * seconds);
    var variation = (parseFloat(this.host.dataset.tcWallVariation) || 0) / 100;
    var DRIFT = [0, 1, 0.08, 0.6, 0.3, 0.9];
    var self = this;
    cols.forEach(function (col, c) {
      var duration = (distances[c] / self.wallPace) * (1 + variation * DRIFT[c % DRIFT.length]);
      var current = parseFloat(col.style.getPropertyValue('--tg-wall-speed'));
      /* A new duration restarts the loop's clock, so a measurement that moved
         by a pixel or two is not worth the visible jump. */
      if (current && Math.abs(current - duration) / current < 0.02) return;
      col.style.setProperty('--tg-wall-speed', duration.toFixed(2) + 's');
      col.style.setProperty('--tc-col-delay', (-(duration / cols.length) * c * 0.37).toFixed(2) + 's');
    });
  };

  Grid.prototype.openPopup = function (li) {
    var card = li.querySelector('.testimonial-card');
    if (!card) return;
    var dialog = this.host.querySelector('.sugar-testimonial-grid__popup');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'sugar-testimonial-grid__popup';
      dialog.innerHTML = '<div class="sugar-testimonial-grid__popup__card"></div><button type="button" class="sugar-testimonial-grid__popup__close" aria-label="Close">&times;</button>';
      /* Inside the host, so the grid's Highlight Background reaches the open
         review's words too. */
      this.host.appendChild(dialog);
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('.sugar-testimonial-grid__popup__close')) dialog.close();
      });
    }
    var body = dialog.querySelector('.sugar-testimonial-grid__popup__card');
    body.innerHTML = '';
    /* A review with a photo opens wider, photo beside the text on desktop. */
    dialog.classList.toggle('sugar-testimonial-grid__popup--media', card.classList.contains('testimonial-card--media'));
    var clone = card.cloneNode(true);
    var more = clone.querySelector('.testimonial-card__more');
    if (more) more.parentNode.removeChild(more);
    paintHighlights(clone);
    body.appendChild(clone);
    if (dialog.showModal) dialog.showModal();
  };

  /* -- Masonry --

     Cards keep their document order and each claims as many fine grid rows as
     it is tall, so the next card in a column starts where the one above it
     ended instead of at the bottom of the tallest card in its row. The list's
     row gap is set to 0 while packed and each card claims its own height plus
     the gap instead: a gap between every fine row would be counted once per
     row, and rounding to a row plus a gap grew each gap by up to that much.
     A single column needs no packing, so it keeps the plain grid rows. */

  Grid.prototype.setupMasonry = function () {
    if (!this.host.hasAttribute('data-tc-masonry')) return;
    this.masonry = true;

    var self = this;
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(function () { self.relayout(); });
      this.items().forEach(function (item) { self.observer.observe(item); });
    }

    window.addEventListener('resize', function () { self.relayout(); });
    document.addEventListener('visibilitychange', function () { self.relayout(); });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { self.relayout(); });
    }
  };

  /* A hidden tab never runs an animation frame, so packing would wait there
     forever; a timeout still lands and costs nothing when the tab is visible. */
  function schedule(fn) {
    return document.hidden ? window.setTimeout(fn, 0) : window.requestAnimationFrame(fn);
  }

  Grid.prototype.relayout = function () {
    if (this.wall) { this.paceWall(); return; }
    if (!this.masonry || this.frame) return;
    var self = this;
    this.frame = schedule(function () {
      self.frame = 0;
      self.pack();
    });
  };

  Grid.prototype.pack = function () {
    var list = this.list;
    var items = this.items();
    var cs = getComputedStyle(list);
    var cols = cs.gridTemplateColumns.split(' ').filter(Boolean).length;
    if (cols < 2) {
      if (list.style.gridAutoRows) {
        list.style.gridAutoRows = '';
        list.style.rowGap = '';
        list.style.marginBottom = '';
        items.forEach(function (item) { item.style.gridRowEnd = ''; });
      }
      return;
    }
    /* The gap the merchant set, which the list itself no longer shows once
       packed (inline row-gap 0). */
    var gap = parseFloat(cs.getPropertyValue('--tg-row-gap'));
    if (isNaN(gap)) gap = list.style.rowGap ? 0 : parseFloat(cs.rowGap) || 0;
    /* Measure every card, then span every card: a write between two reads
       would make each card's height cost a fresh layout of the page. */
    var heights = items.map(function (item) {
      return item.offsetParent === null ? 0 : item.getBoundingClientRect().height;
    });
    var total = heights.reduce(function (sum, h) { return sum + (h ? h + gap : 0); }, 0);
    var unit = Math.max(1, Math.ceil((total / cols) * 1.5 / ROW_LINES));
    /* Set here rather than in the stylesheet: fine rows with no spans yet
       would stack every card on top of the last until this first runs. */
    list.style.gridAutoRows = unit + 'px';
    list.style.rowGap = '0px';
    /* Every card carries the gap below it, so the tallest column ends one gap
       past its last card; the list takes it back. */
    list.style.marginBottom = -gap + 'px';
    items.forEach(function (item, i) {
      if (heights[i]) item.style.gridRowEnd = 'span ' + Math.max(1, Math.round((heights[i] + gap) / unit));
    });
  };

  /* ---- wiring --------------------------------------------------------- */

  var grids = new WeakMap();

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var hosts = Array.prototype.slice.call(scope.querySelectorAll('[data-tc-host]'));
    if (scope !== document && scope.matches && scope.matches('[data-tc-host]')) hosts.push(scope);

    hosts.forEach(function (host) {
      fillCards(host);
      setupVideos(host);
      /* A grid whose cards open the full review shows the photo there instead. */
      if (!(host.hasAttribute('data-tc-grid') && host.dataset.tcWallClick === 'popup')) setupLightbox(host);
      /* The editor re-sends block select/deselect on a host that is already
         wired. Building a second Grid on top of the first would deal the wall's
         cards out again (clones included) and double the loop's distance each
         time, so an existing grid just refreshes its clamps. */
      var existing = grids.get(host);
      if (existing) {
        if (existing.clamp) existing.clamp();
        return;
      }
      if (host.hasAttribute('data-tc-grid')) {
        var grid = new Grid(host);
        grids.set(host, grid);
        grid.clamp = function () { setupClamp(host, function () { grid.relayout(); }); };
        grid.clamp();
      } else {
        setupClamp(host);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var host = event.target.closest ? event.target.closest('[data-tc-host]') : null;
    if (host) init(host);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var host = event.target.closest ? event.target.closest('[data-tc-host]') : null;
    if (host) init(host);
  });
})();
